module.exports = __webpack_public_path__ + "static/media/icon1.82d28f72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/LAMI/icon1.svg
// module id = 92
// module chunks = 0